import backboneHistoryShim from 'js/common/utils/backboneHistoryShim';

// Helper method to call backboneHistoryShim to perform a redirect
export default function redirectTo(fragment: string) {
  backboneHistoryShim.navigate(fragment, {
    trigger: true,
    replace: true, // replace browser history
  });
}
